<template>
  <div class="layout-footer">
    <div class="footer footer-sp-bottom">
      <div class="copyright">
        <p>Copyright © lowcarboyui.com All Rights Reserved.</p>
      </div>

      <div class="mobile-fixed">
        <div class="contact">
          <a
            href="https://lowcarboyui.base.shop"
            target="_blank"
            rel="noopener noreferrer"
            ><span>オンラインショップ</span>
          </a>
        </div>
        <div class="tel">
          <a href="tel:0582665004">
            <img :src="`${rootUrl}/img/yui-top-pa001.png`" alt="ロゴ" /><span
              >お電話でのお問い合わせ</span
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LayoutFooter",
  components: {},
  props: {
    path: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
.tokuteisho {
  text-align: center;
  margin-bottom: 5px;
  a {
    text-decoration: none;
    color: black;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
.footer {
  background-color: var(--main);
  height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 767px) {
    align-items: center;
  }

  .copyright {
    font-size: 13px;
    color: white;
    // margin-right: 200px;
    @media screen and (max-width: 767px) {
      margin-right: 0;
    }
  }
}
.mobile-fixed {
  display: none;
  @media screen and (max-width: 767px) {
    display: flex;
    justify-content: space-around;
    position: fixed;
    bottom: 10px;
    width: 100%;
    height: 2.5em;
    // background-color: rgba(255, 255, 255, 0.7);
    align-items: center;
    z-index: 999;

    a {
      text-decoration: none;
      color: white;
    }

    .contact,
    .tel {
      width: 48%;
      text-align: center;
      padding: 10px 0;
      font-size: 13px;
      vertical-align: middle;
      margin: 0;

      img {
        width: 10px;
        vertical-align: middle;
        margin-right: 3px;
      }
      span {
        vertical-align: middle;
      }
    }
    .contact {
      // background-color: #CBE9E9;
     background-color: #545454;
      color: white;
      // height: 35px;
    }
    .tel {
      background-color: var(--main);
      // color: black!important;
      // font
    }
  }
}

.footer-sp-bottom {
  @media screen and (max-width: 767px) {
    margin-bottom: 50px;
  }
}
</style>
